import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	ButtonComponent,
	CollapseComponent,
	DividerComponent,
	IconComponent,
	InfoGroupComponent,
	TileComponent,
	CopyTextComponent,
	EmptyStateComponent,
} from '@tecalisdev/infinity';
import { formatDate, formatDuration, NOT_AVAILABLE_DISPLAY } from '../../../../core/utils/utils';
import { MasterService } from '../../../../shared/services/master.service';
import { NavigationService } from '../../../../shared/services/navigation.service';
import { IOperationDocumentsDetail } from '../../../models/processes.models';
import { ProcessHelperService } from '../../../services/process-helper.service';
import { OPERATION_STATUS } from '../../../../operations/models/operations.models';
import { DeveloperCurlButtonComponent } from '../../../../shared/components/developer-curl-button/developer-curl-button.component';
import { OperationDocumentListItemComponent } from '../../../../shared/components/operations/documents/operation-document-list-item/operation-document-list-item.component';

@Component({
	selector: 'app-operation-detail-documents',
	imports: [
		TranslatePipe,
		InfoGroupComponent,
		IconComponent,
		CollapseComponent,
		TileComponent,
		DividerComponent,
		ButtonComponent,
		CopyTextComponent,
		EmptyStateComponent,
		DeveloperCurlButtonComponent,
		OperationDocumentListItemComponent,
	],
	templateUrl: './operation-detail-documents.component.html',
	styleUrl: './operation-detail-documents.component.scss',
})
export class OperationDetailDocumentsComponent {
	@Input() operation?: IOperationDocumentsDetail;
	@Input() processUuid?: string;
	@Input() expanded?: boolean = false;
	@Output() toggleCollapse = new EventEmitter<boolean>();

	public masterService = inject(MasterService);
	public processHelper = inject(ProcessHelperService);
	private navigationService = inject(NavigationService);

	public OPERATION_STATUS = OPERATION_STATUS;

	public get operationCurlPath(): string {
		return this.processUuid && this.operation?.uuid
			? `/process/${this.processUuid}/operations/${this.operation.uuid}`
			: '';
	}

	public formatDate(dateString?: string): string {
		if (!dateString) return NOT_AVAILABLE_DISPLAY;
		return formatDate(dateString);
	}

	public formatDuration(durationInSeconds?: number): string {
		return formatDuration(durationInSeconds);
	}

	/**
	 * Abre un documento en una nueva ventana del navegador.
	 *
	 * @param url - La URL del documento que se va a abrir. Si es una cadena vacía o nula, no se realiza ninguna acción.
	 */
	public openDocument(url: string): void {
		if (url) window.open(url, '_blank');
	}

	public goToOperationDetail(operationUuid?: string, event?: Event): void {
		if (!operationUuid) return;
		this.navigationService.navigateTo({ routeSegments: ['operations', 'detail', operationUuid] }, event);
	}
}
